import BaseView from './BaseView';

let view = null;

class Cases extends BaseView {
	constructor(container) {
		super(container);
	}

	init() {
		this.casesWrapper = this.container.querySelector('[data-cases-wrapper]');
        this.extendedCases = this.container.querySelector('[data-cases-extended]');
        this.overviewButton = this.container.querySelector('[data-overview-button]');

		if (this.overviewButton) {
			this.overviewButton.addEventListener('click', () => {
				if (window.innerWidth <= 768) {
					if (this.extendedCases && this.extendedCases.style.maxHeight) {
						this.extendedCases.style.maxHeight = null;
						this.extendedCases.style.opacity = null;
						this.casesWrapper.classList.remove('open');
					} else {
						this.extendedCases.style.maxHeight = this.extendedCases.scrollHeight + "px";
						this.extendedCases.style.opacity = 1;
						this.casesWrapper.classList.add('open');
					}
				}
			});
		}
    }


	destroy() {
		super.destroy();
	}
}

export default {
	namespace: 'template-cases',
	beforeEnter: ({ current, next, trigger }) => {
		view = new Cases(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};